// @flow
import React from 'react';
import injectSheet from 'react-jss';
import Slot from 'shared/editor/Slot';
import type { $Slot } from '../../../types';
import Icon from '@ff/ui/Icon';
import { styled } from '@ff/ui';
import Label from '@ff/ui/Label';
import withThemeProvider from 'shared/hoc/withThemeProvider';
import Button from '@ff/ui/Button';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type TemplateSettings = {
  error_text: string,
  error_code: string,
  cta_text: string,
  cta_url: string
};

type Props = {
  classes: Object,
  slots: $Slot[],
  templateSettings: TemplateSettings,
  widgetPresets: Array,
  path: string
}

function ErrorPage({ classes: c, slots, templateSettings, widgetPresets, path }: Props) {
  return (
    <div className={c.container}>
      <div className={c.menu}>
        <Slot id={'menu-bar'} slots={slots} widgetPresets={widgetPresets} path={path} />
      </div>
      <div className={c.content}>
        <div className={c.errorText}>{templateSettings.error_text}</div>
        <div className={c.errorCode}>{templateSettings.error_code}</div>
        <Button
          variant="primary"
          onClick={() => (window.location.href = templateSettings.cta_url)}
        >
          <CtaLinkLabel>{templateSettings.cta_text}</CtaLinkLabel>
          <CtaButtonIcon name="ff-icon-long-arrow-right" />
        </Button>

      </div>
      <footer id="footer" className={c.footer}>
        <Slot id={'footer'} slots={slots} widgetPresets={widgetPresets} path={path} />
      </footer>
    </div>
  );
}

const CtaLinkLabel = styled(Label.L4)({
  display: 'inline',
  letterSpacing: '1.2px',
});

const CtaButtonIcon = styled(Icon)({
  marginLeft: '10px',
});

const styles = {
  container: {
    backgroundColor: '#f7f7f7',
    fontFamily: FONT_FAMILY_ROBOTO,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  menu: {
    width: '100%',
    position: 'relative',
    zIndex: '10'
  },
  content: {
    width: '100%',
    maxWidth: '620px',
    minHeight: '85%',
    margin: 'auto',
    paddingTop: '160px',
    paddingBottom: '36px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  errorText: {
    fontSize: '14px',
    fontWeight: '300',
    textTransform: 'uppercase'
  },
  errorCode: {
    fontSize: '168px',
    marginTop: '18px',
    marginBottom: '36px',
    fontWeight: '300',
    letterSpacing: '3',
    '@media(max-width: 768px)': {
      fontSize: '108px'
    }
  },
  footer: {
    width: '100%'
  }
};

export default withThemeProvider(injectSheet(styles)(ErrorPage));
